const USER_STATUSES = {
  notConfirmed: 0,
  confirmed: 1,
  approved: 2,
  superior: 3,
};

export default USER_STATUSES;


// WEBPACK FOOTER //
// ./src/constants/userStatuses.js